import React, { useState } from "react";
import SignInPage from "./SignIn";
import SignUpPage from "./SignUpPage";

import toast from "react-hot-toast";
import ReactHotToaster from "../../components/common/ReactHotToaster";

import axiosConfig from "../../axios/axiosConfig";
import { useSelector, useDispatch } from "react-redux";
import { useNavigate, useLocation } from "react-router-dom";
import { LOGIN_SUCCESS } from "../../reduxStore/actions/types";
import {
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  Typography,
} from "@mui/material";
// import HomePage from "../../pages/HomePage";
// import HomePageLayout from "../../Layout/HomePageLayout";

const LoginScreen = () => {
  const userState = useSelector((store) => store.auth);
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const location = useLocation();

  const [displaySignUpPage, setDisplaySignUpPage] = useState(false);

  const [userEmail, setUserEmail] = useState(null);
  const [userPassword, setUserPassword] = useState(null);
  // const [reUserPassword, setReUserPassword] = useState("");

  const [mobileOTP, setMobileOTP] = useState("");
  // const [sessionID, setSessionID] = useState("");

  const [userDetails, setUserDetails] = useState({
    phone: "", // removed 91
    country: "India",
    countryCode: "in",
    dialCode: "91",
  });
  const [otpCooldownUntil, setOtpCooldownUntil] = useState(0);
  const [confirmLogout, setConfirmLogout] = useState(false);
  const [showSessionPopup, setShowSessionPopup] = useState(false);
  const [userCoords, setUserCoords] = useState(null);

  // Always asks for a fresh location fix — never cached/reused across attempts.
  // Rejects if unsupported/denied/timed out, so OTP verification can be blocked without a location fix.
  const getUserLocation = () => {
    return new Promise((resolve, reject) => {
      if (!navigator.geolocation) {
        reject(new Error("Location is not supported on this browser/device"));
        return;
      }
      navigator.geolocation.getCurrentPosition(
        (position) => {
          const coords = {
            latitude: position.coords.latitude,
            longitude: position.coords.longitude,
          };
          setUserCoords(coords);
          localStorage.setItem("userCoords", JSON.stringify(coords));
          resolve(coords);
        },
        () => {
          reject(
            new Error(
              "Location permission is required to verify OTP. Please allow location access and try again."
            )
          );
        },
        { enableHighAccuracy: false, timeout: 10000, maximumAge: 0 }
      );
    });
  };
  console.log(userCoords, "userCoords")

  // Best-effort public IP lookup via a third-party service. Does not block
  // OTP verification if it fails — resolves to null instead of rejecting.
  const getUserIP = async () => {
    try {
      const res = await fetch("https://api.ipify.org?format=json");
      const data = await res.json();
      return data?.ip || null;
    } catch (error) {
      console.log("IP fetch failed: ", error);
      return null;
    }
  };

  const routeToHome = (responseData = null) => {
    const userType = responseData?.response?.user_type?.toLowerCase();

    if (userType === "investor") {
      navigate("/investor");
      return;
    }

    if (location.pathname === "/login" || location.pathname === "/register") {
      navigate("/home");
    }
    // else: already on the protected page — the LOGIN_SUCCESS dispatch above
    // updates redux auth state, which re-renders it in place without a reload
  };

  // onchange handler for phone, country
  const phoneInputOnChange = (value, data, event, formattedValue) => {
    setUserDetails((prev) => {
      return {
        ...prev,
        // phone: formattedNumber,
        phone: value,
        country: data.name,
        countryCode: data.countryCode,
        dialCode: data.dialCode,
      };
    });
  };

  // SETTING TOKEN AND USER DETAILS IN LOCAL STORAGE
  const setLocalStorage = (responseData) => {
    if (responseData.access_token) {
      const allUserDetails = {
        ...responseData,
        userDetails: responseData.response,
      };
      localStorage.setItem("user", JSON.stringify(allUserDetails));

      // Update redux auth state immediately so protected routes re-render
      // without needing a full page reload
      dispatch({
        type: LOGIN_SUCCESS,
        payload: { user: allUserDetails },
      });

      routeToHome(responseData);
    }
  };

  // splitting with dialcode to get mobile number without code
  const formattedMobileNumber = userDetails?.phone.replace(
    new RegExp(`^${userDetails?.dialCode}`),
    ""
  );

  // GET OTP and LOGIN for Indian users ONLY, send all details (phone, email and password) to avoid erros
  // difference function in 'SignIn' for international users (redux dispatch)
  const OTP_COOLDOWN_MS = 5 * 60 * 1000;

  const getOTPLogin = async () => {
    if (Date.now() < otpCooldownUntil) return;
    try {
      const res = await axiosConfig({
        method: "post",
        // url: "/enroll/login",
        url: "/enroll/user_register",
        data: {
          phoneno: formattedMobileNumber,
          // phoneno: userDetails?.phone, // '91' separate in new api
          country: userDetails?.dialCode, // country dial code
          referred_by: null,
          // email: userEmail,
          // password: userPassword,
        },
      });
      console.log(res, "res");
      // If successful
      if (res.status === 200 || res.statusText === "OK") {
        // setSessionID(res.data.Details);
        setOtpCooldownUntil(Date.now() + OTP_COOLDOWN_MS);
        const TOAST_MSG =
          "OTP sent to mobile, please type OTP and click Verify OTP";
        toast.success(TOAST_MSG, {
          duration: 6000,
          position: "top-center",
        });
      }
    } catch (error) {
      console.log(error);
      const ERROR_MSG = error.message;
      toast.error(ERROR_MSG || "Something went wrong", {
        duration: 6000,
        position: "top-center",
      });

      if (ERROR_MSG.toLowerCase() === "user is deactivated") {
        navigate("/activate-account");
      }
    }
  };

  // Verify OTP and Login (FOR INDIAN USERS ONLY)
  const verifyOTPLogin = async (forceLogoutParam = false) => {
    const forceLogout =
      typeof forceLogoutParam === "boolean" ? forceLogoutParam : false;

    // Location is mandatory — block OTP verification until it's granted.
    // getUserLocation() triggers the browser's own native permission prompt.
    let coords;
    try {
      coords = await getUserLocation();
    } catch (locError) {
      toast.error(
        locError.message ||
          "Location permission is required to verify OTP.",
        {
          duration: 6000,
          position: "top-center",
        }
      );
      return;
    }

    const ipAddress = await getUserIP();

    try {
      const res = await axiosConfig({
        method: "post",
        url: "/enroll/web-verifyotp",
        data: {
          // phoneno: parseInt(userDetails.phone),
          phoneno: formattedMobileNumber,
          country: userDetails?.dialCode, // country dial code
          otp: mobileOTP,
          device_name: "",
          device_type: "",
          confirm_logout: forceLogout,
          latitude: coords.latitude,
          longitude: coords.longitude,
          ip_address: ipAddress,
          // session_id: sessionID,
        },
      });

      if (res.status === 200 || res.statusText === "OK") {
        // Indian User Authorized
        setLocalStorage(res.data);
        toast.success("OTP verified successfully!", {
          duration: 6000,
          position: "top-center",
        });
      }
    } catch (error) {
      if (error.response?.status === 403) {
        setShowSessionPopup(true);
        return;
      }
      const ERROR_MSG = error.response.data.response || "Something went wrong";
      toast.error(ERROR_MSG || "Something went wrong", {
        duration: 6000,
        position: "top-center",
      });
    }
  };

  // If user is already logged in
  if (userState?.isLoggedIn) {
    return (
      <>
        <h1>You are logged In</h1>
        {/* <button onClick={() => navigate(-1)}>go back</button> */}
        <button onClick={() => navigate("/home")}>home</button>
      </>
    );
  }

  const handleConfirmLogout = async () => {
    setShowSessionPopup(false);
    await verifyOTPLogin(true);
  };

  if (displaySignUpPage) {
    return (
      <>
        <SignUpPage
          // displaySignUpPage={() => setDisplaySignUpPage(false)}
          setDisplaySignUpPage={setDisplaySignUpPage}
          userDetails={userDetails}
          setUserDetails={setUserDetails}
          phoneInputOnChange={phoneInputOnChange}
          routeToHome={routeToHome}
        />
      </>
    );
  }

  return (
    <>
      <SignInPage
        // displaySignUpPage={() => setDisplaySignUpPage(true)}
        setDisplaySignUpPage={setDisplaySignUpPage}
        getOTPLogin={getOTPLogin}
        otpCooldownUntil={otpCooldownUntil}
        verifyOTPLogin={verifyOTPLogin}
        userEmail={userEmail}
        setUserEmail={setUserEmail}
        userPassword={userPassword}
        setUserPassword={setUserPassword}
        userDetails={userDetails}
        setUserDetails={setUserDetails}
        mobileOTP={mobileOTP}
        setMobileOTP={setMobileOTP}
        phoneInputOnChange={phoneInputOnChange}
        routeToHome={routeToHome}
      />

      {/* ✅ Custom Popup Dialog */}
      <Dialog
        open={showSessionPopup}
        onClose={() => setShowSessionPopup(false)}
        maxWidth="xs"
        fullWidth
      >
        <DialogTitle sx={{ fontWeight: "bold", textAlign: "center" }}>
          Session Active
        </DialogTitle>
        <DialogContent>
          <Typography align="center" sx={{ mt: 1, mb: 1 }}>
            You're already logged in on another device. Do you want to log out
            there and continue here?
          </Typography>
        </DialogContent>
        <DialogActions sx={{ justifyContent: "center", mb: 1 }}>
          <Button
            variant="outlined"
            onClick={() => setShowSessionPopup(false)}
            color="error"
          >
            Cancel
          </Button>
          <Button
            variant="contained"
            color="success"
            onClick={handleConfirmLogout}
          >
            Log out other device
          </Button>
        </DialogActions>
      </Dialog>

      {/* React Hot Toast */}
      <ReactHotToaster />
    </>
  );
};

export default LoginScreen;
